import React, {useState, useEffect} from "react";
import "./Immersion.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Immersion = ({connected, events = []}) => {
    // State to track the active dot, 0 is the first dot.
    const [activeDot, setActiveDot] = useState(events.length);

    useEffect(() => {
        // Look at the newest entry in the events array.
        switch (events[events.length-1]) {
            case "start_intro_triggered":
                setActiveDot(0);
                break;
            case "trip_started":
                setActiveDot(1);
                break;
            case "enter_middlestation_triggered":
                setActiveDot(2);
                break;
            case "leave_middlestation_triggered":
                setActiveDot(3);
                break;
            case "enter_tunnel_triggered":
                setActiveDot(4);
                break;
            case "leave_tunnel_triggered":
                setActiveDot(5);
                break;
            case "game_end_success_triggered":
                setActiveDot(6);
                break;
        }
    }, [events]);

    // Create an array for 7 dots
    const dots = Array.from({length: 7}, (_, i) => i);
    const titles = ["Intro", "Trip Started", "Middle station", "Trip After", "Tunnel", "After Tunnel", "Arriving"];

    // Calculate the width of the progress line based on the active dot.
    const progressWidth = activeDot > 0 ? (activeDot / (dots.length - 1)) * 100 : 0;

    const mainDiv = (
        <div className="immersion-container">
            <div className="timeline">
                <div className="timeline-progress" style={{width: `${progressWidth}%`}}></div>
                {dots.map((index) => (
                    <React.Fragment key={index}>
                        <div
                            className="timeline-title"
                            style={{left: `${(index / (dots.length - 1)) * 100}%`}}
                        >
                            {titles[index] || ''}
                        </div>
                        <div
                            className={`timeline-dot ${activeDot >= index ? 'active' : ''}`}
                            // Position dots evenly along the timeline
                            style={{left: `${(index / (dots.length - 1)) * 100}%`}}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );

    return (
        <RiddleCard mainInfo={mainDiv} layout={"full-size"} title={"Timeline"} connected={connected}/>
    );
};

export default Immersion;